import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StorageService } from '../../../services/storage.service';

@Component({
    selector: 'app-admin-dashboard',
    imports: [RouterModule],
    templateUrl: './admin-dashboard.component.html',
    styleUrl: './admin-dashboard.component.scss'
})
export class AdminDashboardComponent {

  constructor(private storageService: StorageService) {}

  openPdfInNewTab(pdfName: string): void {
    this.storageService.downloadFile(pdfName);
  }
}
